import React from "react";

import { copy } from "shared/assets";
import { AddressInfo as Component } from "shared/components";
import { MutedText } from "shared/styles";
import { IAddress } from "shared/types";

interface AddressInfoProps {
  showPlaceholder?: boolean;
  address?: IAddress;
}

const { placeholder } = copy;

export const AddressInfo: React.FC<AddressInfoProps> = ({ showPlaceholder, address }) => {
  if (!address && !showPlaceholder) return null;

  return address ? <Component address={address} /> : <MutedText>{placeholder.address}</MutedText>;
};
